import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  stripeCustomerState: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: null,
  },
  postApiStatus: {
    statusCode: null,
    statusText: null,
    data: null,
  },
};

export const stripeCustomerSlice = createSlice({
  name: "stripeCustomer",
  initialState: INITIAL_STATE,
  reducers: {
    fetchStripeCustomer: (state) => {
      state.stripeCustomerState.isLoading = true;
    },
    fetchStripeCustomerSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      stripeCustomerState: {
        ...state.stripeCustomerState,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    fetchStripeCustomerFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      stripeCustomerState: {
        ...state.stripeCustomerState,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
    updateStripeCustomerBillingAddress: (state) => {
      state.stripeCustomerState.isLoading = true;
    },
    updateStripeCustomerBillingAddressSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      stripeCustomerState: {
        ...state.stripeCustomerState,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    updateStripeCustomerBillingAddressFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      stripeCustomerState: {
        ...state.stripeCustomerState,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
    clearStripeCustomer: (state) => ({
      ...state,
      stripeCustomerState: {
        ...state.stripeCustomerState,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: null,
        statusText: null,
        data: null,
      },
    }),
  },
});

export const {
  fetchStripeCustomer,
  fetchStripeCustomerFailure,
  fetchStripeCustomerSuccess,
  updateStripeCustomerBillingAddress,
  updateStripeCustomerBillingAddressSuccess,
  updateStripeCustomerBillingAddressFailure,
  clearStripeCustomer,
} = stripeCustomerSlice.actions;
export const stripeCustomerReducer = stripeCustomerSlice.reducer;
